var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_vm._v("\n  Page Not found\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }